// extracted by mini-css-extract-plugin
export default {"container":"YO-z","topReviewHeading":"ZO-z","criticalReview":"_O-z","favorableReview":"aP-z","vsSeparator":"bP-z"};